/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import Utils from '../../../utils/utils';

@Component({
    selector: 'app-report-filter',
    templateUrl: './report-filter.component.html',
})
export class ReportFilterComponent {
    @Input() reportFilterForm!: FormGroup;
    @Input() deviceIdList: any;
    @Input() parameterIdList: any;
    @Input() columnFieldList: any;
    @Input() zerocalibrationBtn!: boolean;
    @Input() hasParameterDropdown!: boolean;
    @Output() reportFilterForms = new EventEmitter<FormGroup>();

    utils = Utils;
    environment = environment;
    intervals = [
        { id: 'As It Is', value: 'As It Is', type: 'As It Is' },
        { id: '1 min', value: '1 min', type: 1 },
        { id: '15 min', value: '15 min', type: 15 },
        { id: '1 hour', value: '1 hour', type: 60 },
    ];

    onDeviceIdChange() {
        this.reportFilterForms.emit(this.reportFilterForm);
    }
}
